/** Product version shown in the application UI. Keep in sync with the root package.json. */
export const APP_VERSION = '1.0.0';
